import { Component } from "@angular/core";

@Component({
  selector: "page-not-found",
  templateUrl: "Page_Not_Found.html"
})

export class Page_Not_Found_Component { }
